module.exports = __webpack_public_path__ + "img/redgantanhao1.2aca0059.svg";